























import { Component, Emit, PropSync, Vue } from 'vue-property-decorator'
import { Question, SelectableAnswer, SuggestionAnswer } from '../../controllers/Chat'

  @Component
export default class SuggestionsAnswerComponent extends Vue {
  @PropSync('question', { required: true, type: Question })
  syncQuestion: Question
  answer: SuggestionAnswer = null
  selection : any = null

  /* mockQuestion : Question = new Question(1, '¿Que quieres hacer?')
  mockOptions : Array<any> = [
    { 'text': 'Option 1', 'color': '' },
    { 'text': 'Example', 'icon': 'mdi-account-outline', 'color': 'primary' },
    { 'text': 'Update Settings', 'icon': 'mdi-wrench', 'color': 'deep-purple accent-4' },
    { 'text': 'New Posts Available', 'icon': 'mdi-fire', 'color': 'indigo darken-3' }
  ] */

  created () {
    this.answer = this.syncQuestion.answer as SelectableAnswer
  }

  @Emit('validAnswer')
  addText () : any {
    console.log(this.selection)
    return this.selection
  }
}
